import { Box, Flex } from '@chakra-ui/react';
import { useMODataContext } from 'src/features/MO/contexts/MODataContext';

export const OptimizationHeader: React.FC = () => {
  const { marginPct } = useMODataContext();

  return (
    <Flex
      fontWeight="bold"
      textAlign={{ lg: 'right', xl: 'left' }}
      whiteSpace={{ base: 'normal', md: 'nowrap' }}
      bg="surface.control"
      flexDir={{ base: 'column', md: 'row' }}
      wrap={{ base: 'wrap', md: 'nowrap' }}>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '100%', md: '15%' }}
        minW={{ base: '120px', md: 'auto' }}
        p={4}>
        Optimization name
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '100%', md: '20%' }}
        minW={{ base: '100px', md: 'auto' }}
        p={4}>
        Period
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '50%', md: '15%' }}
        minW={{ base: '80px', md: 'auto' }}
        p={4}>
        Investment
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '50%', md: '15%' }}
        minW={{ base: '80px', md: 'auto' }}
        p={4}>
        Media Effect
      </Box>
      {marginPct !== null && (
        <Box
          fontSize={{ md: 'xs', lg: 'sm' }}
          textAlign={{ lg: 'right', xl: 'left' }}
          fontWeight="medium"
          fontFamily="marketingPage"
          color="text.light.secondary"
          width={{ base: '50%', md: '10%' }}
          minW={{ base: '60px', md: 'auto' }}
          p={4}>
          ROMI
        </Box>
      )}
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '50%', md: '10%' }}
        minW={{ base: '60px', md: 'auto' }}
        p={4}>
        ROI
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="text.light.secondary"
        width={{ base: '50%', md: '5%' }}
        minW={{ base: '40px', md: 'auto' }}
        p={4}>
        Constraint count
      </Box>
    </Flex>
  );
};
